import React, { useEffect , useState } from 'react';
import { useHistory , useParams } from 'react-router-dom';
import { useForm } from "react-hook-form";

import { useGlobalContext } from '../../context/GlobalContext';
import { resetPasswordAction } from '../../../actions/authActions';

import logo from '../../../assets/images/logo.svg';
import './auth.scss';

export default function ResetPasswordPage(props) {

  const history = useHistory();
  const params = useParams();

  const { handleSubmit, register, errors } = useForm();
  const [ context, dispatch ] = useGlobalContext();

  const [ errorReset , setErrorReset] = useState();
  const [ errorPassword , setErrorPassword ] = useState();
  const [ message , setMessage ] = useState();

  const { setDisplayNavBar } = props ;

  useEffect(() => {
    setDisplayNavBar(false);
  }, [setDisplayNavBar]);

  useEffect(() => {
    if (context.auth.message && context.auth.message.reset) {
      setMessage("Le mot de passe a été modifié avec succès. Veuillez vous connecter avec votre nouveau mot de passe.")
    }
    console.log(context.auth.error)
    if (context.auth.error && context.auth.error.data && context.auth.error.data.error === "Your token has expired. Please attempt to reset your password again.") {
      setErrorReset("Votre jeton a expiré. Veuillez réessayer de réinitialiser votre mot de passe.")
    }
    if (context.auth.error && context.auth.error.data && context.auth.error.data.error === "You must enter a password strong enough.") {
      setErrorPassword("Vous devez entrer un mot de passe suffisamment fort.")
    }
  }, [context.auth.message , context.auth.error])

  const submitPassword = (values)  => {
    values.token = params.token
    resetPasswordAction( dispatch , values);
    dispatch({
      type: 'ERROR_AUTH',
      payload: null,
    });
  };

  function renderConfirmPassword() {
    return (
      <form className="form-container" onSubmit={handleSubmit(submitPassword)}>
        
        <img src={logo} alt="logo" className="logo" />

        {!errorReset && !message &&
          <>
            <label htmlFor="password">Mot de passe</label>
            <input
              name="password"
              type="password"
              ref={register({
                required: "Compléter votre mot de passe",
              })}
            />

            {errors.password  && errors.password.message && <p className="error">{errors.password.message}</p>}
            {errorPassword && <p className="error">{errorPassword}</p> }

            <div className="btn-container">
              <button className="btn primary" type="submit">Valider le nouveau mot de passe</button>
            </div>
          </>
        }

        {errorReset && 
          <>
            <p>{errorReset}</p>
            <div className="btn-container">
              <button className="btn primary" onClick={() => history.push("/login")}>Retour à la page de connexion</button>
            </div>
          </>
        }

        {message && 
          <>
            <p>{message}</p>
            <button className="btn primary" onClick={() => history.push("/")}>Retour à la page de connexion</button>
          </>
        }
    
      </form>
    )
  }

  return (
    <div className="login-page bg-login main">

      <div className="col-content">
        {renderConfirmPassword()}
      </div>
    </div>
  );
};